import {createApp} from "vue";
import ExternalJobTiles from "./components/ExternalJobTiles.vue";

const app = createApp({});

app.component('ExternalJobTiles', ExternalJobTiles);
app.mount('.job-module-job-group');
